import Vue from "vue";
import Vuex from "vuex";
import VueCookie from 'vue-cookie'
import apiInterface from "@/api/apiInterface";
const $interface = apiInterface.Interface;
import { post, get } from "@/api/axiosConfig";
import { getInfo, getUser } from "@/api/public";
const $get = get;
const $post = post;

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    loading: false,
    appId: 'CarHobbyWeb',
    appSecret: 'CarHobbyWeb',
    token: '',
    userLog: ''
  },
  mutations: {
    setLoading(state, data) {
      state.loading = data;
    }
  },
  actions: {
    setLoading: () => {
      commit('setLoading', data);
    },
  },
  getters: {
    getLoading: (state) => {
      return state.loading;
    }
  },
  modules: {}
});



// WEBPACK FOOTER //
// ./src/store/index.js